import React, {Component} from 'react'
import {connect} from 'react-redux'
import Subheader from 'material-ui/Subheader'
import {getObjectById, capitalizeFirstLetter} from "utils";

class LanguageHeader extends Component {

    render() {
        if (this.props.language) {
            return (
                <Subheader>{capitalizeFirstLetter(this.props.language.native_name)}</Subheader>
            )
        }
        return null;
    }
}


function mapStateToProps(state, ownProps) {
    return {
        language: getObjectById(state.lang.languages, ownProps.languageId)
    }
}


export default connect(mapStateToProps)(LanguageHeader)


// WEBPACK FOOTER //
// ./src/components/packages/LanguageHeader.js